import { DienstleistungsModule } from './dienstleistungsmodule.enum';
import { Kontaktdaten } from './kontaktdaten';
import { Adresse } from './adresse.model';
import { NetzbetreiberKontaktinfos } from './netzbetreiber-kontaktinfos.model';
import { DienstleistungsModuleBeschreibung } from './dienstleistungsmodulebeschreibung.model';
import { DienstleistungsArt } from './dienstleistungsart.model';

export class Netzbetreiber implements UniqueTeilgebietAndNetzbetreibernummer {
    public name: string;
    public stadtwerkeId: string;
    public teilgebiet: string;
    public netzbetreibernummer: string;
    public geschaeftspartnerId: string;
    public dienstleistungsart: DienstleistungsArt;
    public dienstleistungsmodule: DienstleistungsModule[];
    public westnetzKontaktdaten: Kontaktdaten[];

    public dienstleistungsmoduleBeschreibung?: DienstleistungsModuleBeschreibung[]; // dynamically added to get a valid description

    public kontaktInfos?: NetzbetreiberKontaktinfos;
    public adresse: Adresse;

    public lastChanged: string;
    public lastImportDate?: string;

    public redispatchEnabled?: boolean;

    constructor(name: string, stadtwerkeId: string, teilgebiet: string, netzbetreibernummer: string, geschaeftspartnerId: string) {
        this.name = name;
        this.stadtwerkeId = stadtwerkeId;
        this.teilgebiet = teilgebiet;
        this.netzbetreibernummer = netzbetreibernummer;
        this.geschaeftspartnerId = geschaeftspartnerId;
    }

    public static createEmptyNetzbetreiber(): Netzbetreiber {
        const nb = new Netzbetreiber(null, null, null, null, null);
        nb.dienstleistungsmodule = [];
        nb.westnetzKontaktdaten = [];
        nb.kontaktInfos = new NetzbetreiberKontaktinfos();
        nb.adresse = new Adresse();
        return nb;
    }
}

export interface UniqueTeilgebietAndNetzbetreibernummer {
    teilgebiet: string;
    netzbetreibernummer: string;
}

